import { create } from "zustand"
import { persist, devtools, createJSONStorage } from "zustand/middleware"
import { Session, User } from "../api/types"
import { setAuthToken, setRefreshToken } from "@/api/axios"

interface AuthStore {
  session: Session | null
  user: User | null
  setUser: (user: User | null) => void
  setSession: (session: Session | null) => void
}

export const useAuthStore = create<AuthStore>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        session: null,
        setUser: (user: User | null) => set((old) => ({ ...old, user })),
        setSession: (session: Session | null) => set({ session }),
      }),
      {
        name: `auth`,
        storage: createJSONStorage(() => localStorage),
        onRehydrateStorage: () => (state, error) => {
          if (!error && state?.session?.access_token) {
            setAuthToken(state.session.access_token)
            setRefreshToken(state.session.refresh_token)
          }
        },
      }
    )
  )
)
